import Typography from "@/design-system/Typography";
import Button from "@/design-system/button";
import { languageSelector } from "@/src/contexts";
import Container from "@Components/Container";
import * as stylex from "@stylexjs/stylex";

import Resources from "./NotFound.Resources";
import ResourcesEn from "./NotFound.Resources.En";

export const NotFound = () => {
    const resources = languageSelector(Resources, ResourcesEn);

    return (
        <Container styleX={styles.container}>
            <div style={{ marginBottom: "1rem" }}>
                <svg
                    width="120"
                    height="120"
                    viewBox="0 0 120 120"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle cx="60" cy="60" r="55" stroke="#1B2670" strokeWidth="4" />
                    <text
                        x="60"
                        y="75"
                        textAnchor="middle"
                        fill="#1B2670"
                        fontSize="48"
                        fontWeight="bold"
                        fontFamily="Roboto, sans-serif"
                    >
                        404
                    </text>
                </svg>
            </div>

            <Typography textElement="h1" fontStyle="hM">
                {resources.title}
            </Typography>

            <Typography
                textElement="p"
                fontStyle="BodyL"
                dangerouslySetInnerHTML={{
                    __html: resources.description,
                }}
            />
            <Button as="a" href="/" variant="magentaRound" size="L" isExternal>
                {resources.button}
            </Button>
        </Container>
    );
};

const styles = stylex.create({
    container: {
        gap: "1.5rem",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        textAlign: "center",
        marginLeft: "auto",
        marginRight: "auto",
        maxWidth: "42rem",
        paddingBottom: "4rem",
        paddingTop: "4rem",
    },
});
